function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

export function isValidCpf(raw: string): boolean {
  const digits = digitsOnly(raw);
  if (!/^\d{11}$/.test(digits) || /^(\d)\1{10}$/.test(digits)) return false;

  const values = digits.split("").map(Number);
  const checksum = (length: number) => {
    const sum = values.slice(0, length).reduce((total, digit, index) => total + digit * (length + 1 - index), 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  return values[9] === checksum(9) && values[10] === checksum(10);
}

function domesticPhoneDigits(trimmed: string): string | null {
  const digits = digitsOnly(trimmed);
  if (!trimmed.startsWith("+")) {
    return /^55\d{10,11}$/.test(digits) ? null : digits;
  }
  return trimmed.startsWith("+55") ? digits.slice(2) : null;
}

export function normalizeBrazilianPhone(raw: string): string | null {
  const trimmed = raw.trim();
  const domestic = domesticPhoneDigits(trimmed);
  if (!domestic) return null;
  if (!/^[1-9]\d(?:[2-9]\d{7}|9\d{8})$/.test(domestic)) return null;
  return `+55${domestic}`;
}
